export default {
  session: state => state.session,
  options: state => state.profile.options,
  role: state => state.profile.role,
  user: state => state.user,
  isManager: state => state.profile.role === 'manager',
  usageDatas: state => state.usageDatas,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js